module.exports = __webpack_public_path__ + "img/logout.02984ef5.svg";